import { Navigate, Route, Routes } from "react-router-dom";
import { ProtectedRoute } from "@rekonas/auth";
import { AppShell } from "./components/AppShell";
import { LoginPage } from "./routes/LoginPage";
import { RecordingDetailPage } from "./routes/RecordingDetailPage";
import { RecordingsPage } from "./routes/RecordingsPage";

function AuthenticatedLayout() {
  return <AppShell />;
}

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<ProtectedRoute />}>
        <Route element={<AuthenticatedLayout />}>
          <Route path="/recordings" element={<RecordingsPage />} />
          <Route path="/recordings/:recordingRef" element={<RecordingDetailPage />} />
          <Route path="/" element={<Navigate to="/recordings" replace />} />
          <Route path="*" element={<Navigate to="/recordings" replace />} />
        </Route>
      </Route>
    </Routes>
  );
}
